import cn from 'classnames';
import { type FC } from 'react';
import Skeleton from 'react-loading-skeleton';

type SuggestedQuestionSkeletonCardProps = {
  horizontal?: boolean;
  index: number;
};

const minWidthClasses = [
  'min-w-[190px]',
  'min-w-[270px]',
  'min-w-[180px]',
  'min-w-[250px]',
  'min-w-[220px]',
  'min-w-[200px]',
];

const SuggestedQuestionSkeletonCard: FC<SuggestedQuestionSkeletonCardProps> = ({
  horizontal = false,
  index,
}) => {
  const minWidthClass = minWidthClasses[index % minWidthClasses.length];

  return (
    <div
      className={cn(
        'bg-white rounded-xl p-3 border border-primary-100 max-w-[340px] flex-shrink-0 text-left',
        {
          'max-w-[340px]': horizontal,
          'max-w-[270px]': !horizontal,
        },
        minWidthClass,
      )}
    >
      <div
        className={cn('flex items-start justify-start h-full', {
          'flex-row': horizontal,
          'flex-col': !horizontal,
        })}
      >
        <div className="flex-shrink-0 w-6 h-6 mb-2">
          <Skeleton className="w-full h-full" circle />
        </div>

        <p className="w-full text-sm leading-5 break-words">
          <Skeleton className="w-full h-2" />
        </p>

        <p className="w-full text-sm leading-5 break-words">
          <Skeleton className="w-full h-2" />
        </p>

        <p className="w-[60%] text-sm leading-5 break-words">
          <Skeleton className="w-full h-2" />
        </p>
      </div>
    </div>
  );
};

const SuggestedQuestionSkeleton: FC<{ horizontal?: boolean }> = ({
  horizontal = false,
}) => (
  <>
    {Array(8)
      .fill(0)
      .map((_, index) => (
        <SuggestedQuestionSkeletonCard
          key={index}
          index={index}
          horizontal={horizontal}
        />
      ))}
  </>
);

export default SuggestedQuestionSkeleton;
